import React from 'react';
import { FaPhone } from 'react-icons/fa';
import { CONTACT, phoneHref } from '../constants/contact';
import './PhoneCTA.css';

const PhoneCTA = ({
  variant = 'primary',
  label,
  className = '',
  showNumber = true,
}) => {
  const defaultLabels = {
    primary: 'Call For Instant Quote',
    outline: `Call ${CONTACT.phone}`,
    compact: 'Call Now',
    hero: 'Call us now',
    bar: `Call ${CONTACT.phone}`,
  };

  const text = label || defaultLabels[variant] || defaultLabels.primary;

  return (
    <a
      href={phoneHref}
      className={`phone-cta phone-cta--${variant} ${className}`.trim()}
      aria-label={`Call NX Auto Care at ${CONTACT.phone}`}
    >
      <span className="phone-cta-icon-wrap">
        <FaPhone className="phone-cta-icon" aria-hidden />
      </span>
      <span className="phone-cta-text">
        <span className="phone-cta-label">{text}</span>
        {showNumber && variant !== 'compact' && (
          <strong className="phone-cta-number">{CONTACT.phone}</strong>
        )}
      </span>
    </a>
  );
};

export default PhoneCTA;
